import gql from 'graphql-tag';

export const CREATE_RESULT_TEMPLATE = gql`
  mutation CreateResultTemplate($input: CreateResultTemplateInput!) {
    createResultTemplate(input: $input) {
      id
      name
      code
      style_code
      updated_at
    }
  }
`;

export const UPDATE_RESULT_TEMPLATE = gql`
  mutation UpdateResultTemplate($input: UpdateResultTemplateInput!) {
  updateResultTemplate(input: $input) {
    id
    name
    code
    style_code
    properties
      columns {
      id
      label
      key
      type
      sequence
      is_visible
        school_assessment_type {
        id
        name
      }
    }
  }
}
`;

// UPDATE_RESULT_TEMPLATE_FLAT removed

export const DELETE_RESULT_TEMPLATE = gql`
  mutation DeleteResultTemplate($id: ID!) {
    deleteResultTemplate(id: $id) {
      success
      message
      code
    }
  }
`;

export const ASSIGN_RESULT_TEMPLATE = gql`
  mutation AssignResultTemplateToClassroom(
  $academic_calendar_id: ID!,
  $classroom_id: ID!,
  $result_template_id: ID!,
  $historical_source_map: [HistoricalSourceMapInput!]
) {
  assignResultTemplateToClassroom(
    academic_calendar_id: $academic_calendar_id,
    classroom_id: $classroom_id,
    result_template_id: $result_template_id,
    historical_source_map: $historical_source_map
  ) {
    id
    name
  }
}
`;

export const UNASSIGN_RESULT_TEMPLATE_FROM_PROGRAMME = gql`
  mutation UnassignResultTemplateFromProgramme($programme_id: ID!, $academic_calendar_id: ID!) {
    unassignResultTemplateFromProgramme(programme_id: $programme_id, academic_calendar_id: $academic_calendar_id) {
      success
      message
    }
  }
`;

